<template>
  <td>
    <span v-if="!isDynamic" class="flag-icon" :class="flagClass"></span>
    <span v-html="html"></span>
    <br />
    <span v-if="flagClass" class="flag-icon" :class="flagClass"></span>
    {{ model.user.registered_with_ip }}
  </td>
</template>

<script>
import { defaultNullHtml } from "@/js/defaultNullHtml";
export default {
  props: ["model"],
  computed: {
    html() {
      return this.isDynamic
        ? "dynamisch"
        : this.model.zipcode !== null
        ? this.model.zipcode
        : defaultNullHtml();
    },
    isDynamic() {
      return Boolean(this.model.has_dynamic_zipcode);
    },
    flagClass() {
      return this.isDynamic || !this.model.country
        ? null
        : `flag-icon-${this.model.country.toLowerCase()}`;
    }
  }
};
</script>
